module.exports = __webpack_public_path__ + "img/img18.f78c3a3e.svg";